module.exports = __webpack_public_path__ + "static/media/gp4.e10dc23e.webp";